module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GXZ_3X.890f2b9d.tom";